import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Divider,
  Select,
  Space,
  Switch,
  Typography,
  Tooltip,
  Form as FormInitial,
  Input,
  AutoComplete,
} from "antd";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  InputItem,
  ButtonItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  ErrorItem,
  ModalItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import AgregarMarbetes from "../../Marbetes/AgregarMarbetes/AgregarMarbetes";
import InsumoDetalleRow from "../../../../Components/InsumoDetalleRow";
import AgregarLotes from "../../LotesCaducidades/AgregarLotes/AgregarLotes";
import {
  CalculatorOutlined,
  SearchOutlined,
  HourglassOutlined,
  CheckCircleOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
} from "@ant-design/icons";
import LeerPdf from "../../../../Components/LeerPdf";
import LeerExcelLotes from "../../../../Components/LeerExcelLotes";

const { Option } = Select;

moment.locale("es");

class RecibirInsumosRemision extends Component {
  formRef = React.createRef();
  searchRef = React.createRef();
  state = {
    loading: false,
    datosFactura: undefined,
    objetoInsumos: (
      <Option disabled value={0} key={0}>
        Seleccione un proveedor primero
      </Option>
    ),
    todasInsumos: [],
    objetoProyectos: null,
    todasProyectos: [],
    id: this.props.location.state.id,
    modalAgregarMarbetes: false,
    modalAgregarMarbetesIndex: null,
    modalAgregarMarbetesMarbetes: null,
    mostrarDetalles: true,
    busquedaInsumo: "",
    insumoResaltado: null,
    colapsadoSinRecibir: false,
    colapsadoRecibidos: true,
    modalAgregarLotes: false,
    modalAgregarLotesIndex: null,
    modalAgregarLotesLotes: null,
    modalAgregarLotesVehiculo: false,
    modalAgregarLotesInsumoId : null,
    expandirLotes: false,
    modalLotesRapido: false,
    modalLotesRapidoIndex: null,
    modalLotesRapidoLotes: [],
    capturaModoRapido: false,
    sugerenciasSearch: [],
  };
  componentDidMount() {
    this.consultarTodo();
    this._ctrlBHandler = (e) => {
      if (e.ctrlKey && e.key === 'b') {
        e.preventDefault();
        this.searchRef.current?.focus();
      }
    };
    document.addEventListener('keydown', this._ctrlBHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this._ctrlBHandler);
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "remisiones/datosRemisionPRecibirP",
        {
          empresaId: this.props.empresaId,
          remisionId: this.state.id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState(
            {
              datosFactura: res.data.remision,
              todasInsumos: res.data.insumos,
              objetoInsumos: res.data.insumos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.stringBuscar}
                  </Option>
                );
              }),
              todasProyectos: res.data.proyectos,
              objetoProyectos: res.data.proyectos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            },
            () => {
              this.formRef.current.setFieldsValue({
                insumos: res.data.remision.insumos.map((value) => {
                  return {
                    ...value,
                    precioUnitarioAjustado:
                      value.precioUnitario * (1 - value.descuento / 100),
                  };
                }),
              });
            }
          );
        } else {
          message.error("Error no se encontro informacion de la remisión");
        }
      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    let recibirTodos = 0;
    values.insumos = values.insumos.map((value) => {
      let recibir = value.recibir ? value.recibir : 0;
      recibirTodos += recibir;
      return { ...value, recibir };
    });
    if (recibirTodos === 0)
      return message.info(
        "Se neceitan cantidades para poder hacer esta operación"
      );
    this.setState({ loading: true });
    axios
      .post(
        "remisiones/recibirInsumos",
        {
          ...values,
          empresaId: this.props.empresaId,
          remisionId: this.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se han recibido insumos de la remisión: " + (res.data.codigo || "")
          );
          NotificacionPolizas(res.data.polizasId);
          NotificacionMovimientosInventario(res.data.movimientosIds);
          this.formRef.current.resetFields();
          this.atras(res.data.codigo);
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pueden recibir los insumos");
        } else {
          message.error("Hubo un error y no se recibieron los insumos");
        }
      });
  }
  atras() {
    this.props.history.goBack();
  }
  abrirAgregarMarbetes(value, marbetes) {
    this.setState({
      modalAgregarMarbetes: true,
      modalAgregarMarbetesIndex: value,
      modalAgregarMarbetesMarbetes: marbetes,
    });
  }

  cerrarAgregarMarbetes(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalAgregarMarbetesIndex].marbetes = value;
    this.formRef.current.setFieldsValue({
      insumos: insumos,
    });
    this.setState({
      modalAgregarMarbetes: false,
      modalAgregarMarbetesIndex: null,
      modalAgregarMarbetesMarbetes: null,
    });
  }

  abrirAgregarLotes(value, lotes, vehiculo, insumoId) {
    this.setState({
      modalAgregarLotes: true,
      modalAgregarLotesIndex: value,
      modalAgregarLotesLotes: lotes,
      modalAgregarLotesVehiculo: vehiculo,
      modalAgregarLotesInsumoId : insumoId, 
    });
  }

  cerrarAgregarLotes(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalAgregarLotesIndex].lotes = value;
    this.formRef.current.setFieldsValue({
      insumos: insumos,
    });
    this.setState({
      modalAgregarLotes: false,
      modalAgregarLotesIndex: null,
      modalAgregarLotesLotes: null,
      modalAgregarLotesVehiculo: false,
      modalAgregarLotesInsumoId : null, 
    });
  }
  recibirTodosLosInsumos = () => {
    const form = this.formRef.current;
    if (!form) return;

    const insumos = form.getFieldValue("insumos") || [];

    //Insumos con su 
    const nuevosInsumos = insumos.map((insumo) => {
      const cantidad = Number(insumo.cantidad) || 0;
      const recibido = Number(insumo.recibido) || 0;

      const max = cantidad - recibido;

      return {
        ...insumo,
        recibir: max > 0 ? max : 0,
      };
    });

    form.setFieldsValue({ insumos: nuevosInsumos })

    message.success("Se asignaron cantidades a recibir a todos los insumos");
  }

  agregarLoteDesdeSearch = () => {
    const { insumoResaltado } = this.state;
    if (insumoResaltado === null) return;
    const insumos = this.formRef.current?.getFieldValue('insumos');
    if (!insumos) return;
    const insumo = this.state.todasInsumos?.find(i => i._id === insumos[insumoResaltado]?.insumoId);
    if (!insumo?.lotesCaducidades) return;
    const lotes = insumos[insumoResaltado].lotes || [];
    const newIdx = lotes.length;
    insumos[insumoResaltado].lotes = [...lotes, { numero: '', caducidad: null, cantidad: null }];
    this.formRef.current.setFieldsValue({ insumos });
    if (!this.state.expandirLotes) {
      this.setState({ expandirLotes: true }, () => {
        setTimeout(() => {
          document.getElementById(`lote-numero-${insumoResaltado}-${newIdx}`)?.focus();
        }, 80);
      });
    } else {
      setTimeout(() => {
        document.getElementById(`lote-numero-${insumoResaltado}-${newIdx}`)?.focus();
      }, 50);
    }
  };

  agregarLoteInline = (arrayKey) => {
    const insumos = this.formRef.current.getFieldValue('insumos');
    insumos[arrayKey].lotes = [...(insumos[arrayKey].lotes || []), { numero: '', caducidad: null, cantidad: null }];
    this.formRef.current.setFieldsValue({ insumos });
  };

  eliminarLoteInline = (arrayKey, loteIdx) => {
    const insumos = this.formRef.current.getFieldValue('insumos');
    insumos[arrayKey].lotes = (insumos[arrayKey].lotes || []).filter((_, i) => i !== loteIdx);
    this.formRef.current.setFieldsValue({ insumos });
  };

  updateLoteField = (arrayKey, loteIdx, field, value) => {
    const insumos = this.formRef.current.getFieldValue('insumos');
    if (!insumos[arrayKey].lotes) insumos[arrayKey].lotes = [];
    insumos[arrayKey].lotes[loteIdx] = { ...insumos[arrayKey].lotes[loteIdx], [field]: value };
    this.formRef.current.setFieldsValue({ insumos });
  };

  navegarAInsumo = (index) => {
    const insumos = this.formRef.current?.getFieldValue("insumos") || [];
    this.setState({
      insumoResaltado: index,
      colapsadoSinRecibir: false,
      colapsadoRecibidos: false,
      sugerenciasSearch: [],
      busquedaInsumo: '',
    });
    setTimeout(() => {
      const fila = document.getElementById(`insumo-row-${index}`);
      if (fila) fila.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 100);
    const insumoInfo = this.state.todasInsumos.find(i => i._id === insumos[index]?.insumoId);
    if (this.state.capturaModoRapido && insumoInfo?.lotesCaducidades) {
      this.abrirModalLotesRapido(index);
    } else if (this.state.capturaModoRapido) {
      setTimeout(() => {
        document.querySelector(`#insumo-row-${index} input[placeholder*="Max"]`)?.focus();
      }, 150);
    }
  };

  buscarInsumo = (valor) => {
    this.setState({ sugerenciasSearch: [], busquedaInsumo: '' });
    if (!valor) {
      this.setState({ insumoResaltado: null });
      return;
    }
    const insumos = this.formRef.current?.getFieldValue("insumos") || [];
    const texto = valor.toLowerCase();
    const index = insumos.findIndex((insumo) => {
      const infoInsumo = this.state.todasInsumos.find(i => i._id === insumo.insumoId);
      if (!infoInsumo) return false;
      return (
        infoInsumo.descripcion?.toLowerCase().includes(texto) ||
        infoInsumo.codigo?.toLowerCase().includes(texto) ||
        infoInsumo.clave?.toLowerCase().includes(texto) ||
        infoInsumo.codigoBarras?.toLowerCase().includes(texto)
      );
    });
    if (index === -1) {
      message.warning("No se encontró ningún insumo con ese criterio");
      return;
    }
    this.navegarAInsumo(index);
  };

  onSearchInputChange = (valor) => {
    this.setState({ busquedaInsumo: valor });
    if (!valor) {
      this.setState({ insumoResaltado: null, sugerenciasSearch: [] });
      return;
    }
    if (!this.formRef.current) return;
    const insumos = this.formRef.current.getFieldValue("insumos") || [];
    const texto = valor.toLowerCase();
    const matches = [];
    insumos.forEach((insumo, index) => {
      const infoInsumo = this.state.todasInsumos.find(i => i._id === insumo.insumoId);
      if (!infoInsumo) return;
      if (
        infoInsumo.descripcion?.toLowerCase().includes(texto) ||
        infoInsumo.codigo?.toLowerCase().includes(texto) ||
        infoInsumo.clave?.toLowerCase().includes(texto) ||
        infoInsumo.codigoBarras?.toLowerCase().includes(texto)
      ) {
        matches.push({
          value: `idx-${index}`,
          label: (
            <span>
              <strong style={{ fontSize: 12 }}>{infoInsumo.clave || ''}</strong>
              <span style={{ marginLeft: 6, color: '#555', fontSize: 12 }}>{infoInsumo.descripcion || ''}</span>
            </span>
          ),
          index,
        });
      }
    });
    this.setState({ sugerenciasSearch: matches });
  };

  onSelectSugerencia = (value, option) => {
    if (option?.index == null) return;
    this.navegarAInsumo(option.index);
    setTimeout(() => this.searchRef.current?.focus(), 80);
  };

  abrirModalLotesRapido = (arrayKey) => {
    const insumos = this.formRef.current?.getFieldValue('insumos') || [];
    const existentes = insumos[arrayKey]?.lotes || [];
    const lotes = existentes.length > 0
      ? existentes.map(l => ({ ...l }))
      : [{ numero: '', caducidad: null, cantidad: null }];
    this.setState(
      { modalLotesRapido: true, modalLotesRapidoIndex: arrayKey, modalLotesRapidoLotes: lotes },
      () => setTimeout(() => document.getElementById('rapid-lote-numero-0')?.focus(), 150)
    );
  };

  cerrarModalLotesRapido = () => {
    this.setState({ modalLotesRapido: false, modalLotesRapidoIndex: null, modalLotesRapidoLotes: [], insumoResaltado: null, busquedaInsumo: '', sugerenciasSearch: [] });
    setTimeout(() => this.searchRef.current?.focus(), 80);
  };

  confirmarLotesRapido = () => {
    const { modalLotesRapidoLotes, modalLotesRapidoIndex } = this.state;
    const lotesValidos = modalLotesRapidoLotes.filter(l => l.numero?.toString().trim() || Number(l.cantidad) > 0);
    if (lotesValidos.length === 0) {
      this.setState({ modalLotesRapido: false, modalLotesRapidoIndex: null, modalLotesRapidoLotes: [], insumoResaltado: null });
      setTimeout(() => {
        if (this.searchRef.current?.input) this.searchRef.current.input.value = '';
        this.searchRef.current?.focus();
      }, 80);
      return;
    }
    for (const lote of lotesValidos) {
      if (!lote.numero?.toString().trim()) {
        message.error('El número de lote es requerido en todos los lotes');
        return;
      }
    }
    const suma = lotesValidos.reduce((s, l) => s + (Number(l.cantidad) || 0), 0);
    const insumos = this.formRef.current.getFieldValue('insumos');
    insumos[modalLotesRapidoIndex].lotes = lotesValidos;
    if (suma > 0) insumos[modalLotesRapidoIndex].recibir = suma;
    this.formRef.current.setFieldsValue({ insumos });
    message.success('Lotes guardados');
    this.setState({ modalLotesRapido: false, modalLotesRapidoIndex: null, modalLotesRapidoLotes: [], insumoResaltado: null, busquedaInsumo: '', sugerenciasSearch: [] });
    setTimeout(() => this.searchRef.current?.focus(), 80);
  };

  updateLoteRapido = (idx, field, value) => {
    const lotes = [...this.state.modalLotesRapidoLotes];
    lotes[idx] = { ...lotes[idx], [field]: value };
    this.setState({ modalLotesRapidoLotes: lotes });
  };

  agregarFilaLoteRapido = (cb) => {
    this.setState(
      prev => ({ modalLotesRapidoLotes: [...prev.modalLotesRapidoLotes, { numero: '', caducidad: null, cantidad: null }] }),
      cb
    );
  };

  eliminarFilaLoteRapido = (idx) => {
    this.setState(prev => ({
      modalLotesRapidoLotes: prev.modalLotesRapidoLotes.filter((_, i) => i !== idx)
    }));
  };


  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Recibir Insumos sobre Remisión"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            <Space key="extra-actions" align="center">
              <span style={{ fontSize: 14 }}>
                <strong>Fecha:</strong>{" "}
                {moment(this.state.datosFactura?.createdAt).format("LL")}
              </span>

              <LeerPdf
                rfcProveedor={this.state.datosFactura?.proveedor?.rfc}
                formRef={this.formRef}
                todasInsumos={this.state.todasInsumos}
                onLoadingChange={(v) => this.setState({ loading: v })}
              />
              <LeerExcelLotes
                formRef={this.formRef}
                todasInsumos={this.state.todasInsumos}
                onLoadingChange={(v) => this.setState({ loading: v })}
                titulo={"Lotes Remision"}
              />
            </Space>
          ]}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="recibirInsumosRemision"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Recibir
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row gutter={[16, 8]} style={{
                background: "linear-gradient(135deg, #f8fafc 0%, #f0f4f8 100%)",
                borderRadius: 12,
                padding: "16px 20px",
                marginBottom: 16,
                border: "1px solid #e2e8f0",
                boxShadow: "0 1px 4px rgba(0,0,0,0.06)"
              }}>
                {/* Proyecto */}
                <Col span={6}>
                  <div style={{ borderRight: "1px solid #e2e8f0", paddingRight: 16 }}>
                    <Typography.Text type="secondary" style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1 }}>
                      Proyecto
                    </Typography.Text>
                    <h3 style={{ margin: "2px 0 4px", color: "#1a202c", fontSize: 15 }}>
                      {this.state.datosFactura?.proyecto.nombre}
                    </h3>
                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                      {this.state.datosFactura?.proyecto.descripcion}
                    </Typography.Text>
                  </div>
                </Col>

                {/* Dirección */}
                <Col span={6}>
                  <div style={{ borderRight: "1px solid #e2e8f0", paddingRight: 16 }}>
                    <Typography.Text type="secondary" style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1 }}>
                      Dirección de Envío
                    </Typography.Text>
                    <div style={{ marginTop: 4 }}>
                      {this.state.datosFactura?.proyecto.calle ? (
                        <>
                          <p style={{ margin: 0, fontSize: 13, color: "#2d3748" }}>
                            ðŸ  {this.state.datosFactura?.proyecto.calle} #{this.state.datosFactura?.proyecto.numeroCalle}
                          </p>
                        </>
                      ) : (
                        <>
                          <p style={{ margin: 0, fontSize: 13, color: "#2d3748" }}>ðŸš— {this.state.datosFactura?.proyecto.marca} {this.state.datosFactura?.proyecto.modelo}</p>
                          <p style={{ margin: 0, fontSize: 13, color: "#2d3748" }}>ðŸªª {this.state.datosFactura?.proyecto.placas}</p>
                        </>
                      )}
                    </div>
                  </div>
                </Col>

                {/* Proveedor */}
                <Col span={6}>
                  <div style={{ borderRight: "1px solid #e2e8f0", paddingRight: 16 }}>
                    <Typography.Text type="secondary" style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1 }}>
                      Proveedor
                    </Typography.Text>
                    <h3 style={{ margin: "2px 0 4px", color: "#1a202c", fontSize: 15 }}>
                      {this.state.datosFactura?.proveedor.nombre
                        ? `${this.state.datosFactura?.proveedor.nombre} ${this.state.datosFactura?.proveedor.apellidoPaterno} ${this.state.datosFactura?.proveedor.apellidoMaterno}`
                        : this.state.datosFactura?.proveedor.razonSocial}
                    </h3>
                    <p style={{ margin: 0, fontSize: 12, color: "#4a5568" }}>ðŸ“‹ RFC: {this.state.datosFactura?.proveedor.rfc}</p>
                    <p style={{ margin: 0, fontSize: 12, color: "#4a5568" }}>âœ‰ï¸ {this.state.datosFactura?.proveedor.correo}</p>
                    <p style={{ margin: 0, fontSize: 12, color: "#4a5568" }}>ðŸ“ž {this.state.datosFactura?.proveedor.telefono}{this.state.datosFactura?.proveedor.celular ? ` / ${this.state.datosFactura?.proveedor.celular}` : ""}</p>
                  </div>
                </Col>

                {/* Contacto */}
                <Col span={6}>
                  <Typography.Text type="secondary" style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1 }}>
                    Contacto
                  </Typography.Text>
                  <h3 style={{ margin: "2px 0 4px", color: "#1a202c", fontSize: 15 }}>
                    {this.state.datosFactura?.proveedor.nombreContacto || "â€”"}
                  </h3>
                  <p style={{ margin: 0, fontSize: 12, color: "#4a5568" }}>ðŸ“ž {this.state.datosFactura?.proveedor.telefonoContacto}</p>
                  <p style={{ margin: 0, fontSize: 12, color: "#4a5568" }}>âœ‰ï¸ {this.state.datosFactura?.proveedor.correoContacto}</p>
                  <p style={{ margin: 0, fontSize: 12, color: "#4a5568" }}>
                    ðŸ’³ Crédito: <strong>{this.state.datosFactura?.proveedor.diasCredito} días</strong>
                  </p>
                </Col>
              </Row>

              <Divider style={{ marginBottom: 12, marginTop: 0 }} />

              {/* Formulario + buscador */}
              <Row gutter={[16, 0]} align="middle" style={{ marginBottom: 16 }}>
                <Col span={8}>
                  <FormItem name="codigoRemision" label="Codigo Remision" margin pattern>
                    <InputItem placeholder="Codigo Remision" />
                  </FormItem>
                </Col>
                <Col span={8}>
                  <FormItem
                    label="Fecha de Recepcion"
                    name="fechaRecepcion"
                    required
                    margin
                    initialValue={moment()}
                  >
                    <DatePickerItem placeholder="Fecha de Recepcion" allowClear={false} />
                  </FormItem>
                </Col>
                <Col span={8}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      borderRadius: 8,
                      padding: "6px 12px",
                      height: 32,
                      flex: 1,
                    }}>
                      <Typography.Text style={{ fontSize: 12, color: "#888", whiteSpace: "nowrap" }}>
                        Mostrar detalles
                      </Typography.Text>
                      <Switch
                        size="small"
                        checked={this.state.mostrarDetalles}
                        onChange={(checked) => this.setState({ mostrarDetalles: checked })}
                      />
                    </div>
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      borderRadius: 8,
                      padding: "6px 12px",
                      height: 32,
                      flex: 1,
                    }}>
                      <Typography.Text style={{ fontSize: 12, color: "#888", whiteSpace: "nowrap" }}>
                        Expandir lotes
                      </Typography.Text>
                      <Switch
                        size="small"
                        checked={this.state.expandirLotes}
                        onChange={(checked) => this.setState({ expandirLotes: checked })}
                      />
                    </div>
                    <Tooltip title="Modo para capturar lotes con teclado: busca el insumo y se abre el modal de lotes automáticamente">
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        background: this.state.capturaModoRapido ? "#e6f4ff" : "#f8fafc",
                        border: `1px solid ${this.state.capturaModoRapido ? "#1890ff" : "#e2e8f0"}`,
                        borderRadius: 8,
                        padding: "6px 12px",
                        height: 32,
                        flex: 1,
                      }}>
                        <Typography.Text style={{ fontSize: 12, color: this.state.capturaModoRapido ? "#1890ff" : "#888", whiteSpace: "nowrap", fontWeight: this.state.capturaModoRapido ? 600 : 400 }}>
                          Captura rápida
                        </Typography.Text>
                        <Switch
                          size="small"
                          checked={this.state.capturaModoRapido}
                          onChange={(checked) => this.setState({ capturaModoRapido: checked })}
                        />
                      </div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>

              <Row style={{ marginBottom: 12 }} align="middle" gutter={[8, 0]}>
                <Col span={14}/>
                <Col span={10}>
                  <AutoComplete
                    options={this.state.sugerenciasSearch}
                    onSelect={this.onSelectSugerencia}
                    onChange={this.onSearchInputChange}
                    value={this.state.busquedaInsumo}
                    style={{ width: '100%' }}
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={{ minWidth: 480 }}
                  >
                    <Input.Search
                      ref={this.searchRef}
                      prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                      placeholder={this.state.capturaModoRapido ? "Captura rápida activa â€” escanea o escribe y presiona Enter" : "Buscar (Ctrl+B) Â· Tab para agregar lote al insumo encontrado"}
                      allowClear
                      enterButton="Buscar"
                      size="middle"
                      onSearch={this.buscarInsumo}
                      onKeyDown={(e) => {
                        if (e.key === 'Tab' && this.state.insumoResaltado !== null) {
                          e.preventDefault();
                          this.agregarLoteDesdeSearch();
                        }
                      }}
                      style={{ borderRadius: 8 }}
                    />
                  </AutoComplete>
                </Col>
              </Row>
              <FormInitial.List name="insumos">
                {(fields) => (
                  <>
                    <table className="table">
                      {fields.length > 0 ? (
                        <thead>
                          <tr>
                            <th className="th-border" style={{ width: "24%" }}>Insumo</th>
                            <th className="th-border" style={{ width: "10%" }}>Proyecto</th>
                            <th className="th-border" style={{ width: "16%" }}>Precio Unitario</th>
                            <th className="th-border" style={{ width: "12%" }}>Cantidad Pedida</th>
                            <th className="th-border" style={{ width: "12%" }}>Cantidad recibida</th>
                            <th className="th-border" style={{ width: "16%" }}>
                              Cantidad a recibir
                              <Tooltip title='Recibir todos los insumos.'>
                                <CalculatorOutlined onClick={() => this.recibirTodosLosInsumos()} style={{ marginLeft: '5px', color: 'green' }} />
                              </Tooltip>
                            </th>
                            <th className="th-border" style={{ width: "10%" }}>Accion</th>
                          </tr>
                        </thead>
                      ) : null}

                      {(() => {
                        const pendientes = [];
                        const recibidos = [];

                        fields.forEach((field) => {
                          const arrayKey = field.name;
                          const insumoFactura = this.state.datosFactura?.insumos[arrayKey];
                          const cantidad = Number(insumoFactura?.cantidad) || 0;
                          const recibido = Number(insumoFactura?.recibido) || 0;

                          if (cantidad - recibido <= 0) {
                            recibidos.push({ field, arrayKey, isRecibido: true });
                          } else {
                            pendientes.push({ field, arrayKey, isRecibido: false });
                          }
                        });

                        const renderFila = ({ field, arrayKey, isRecibido }) => {
                          const { key, name, fieldKey, ...restField } = field;
                          return (
                            <FormItem key={key} noStyle shouldUpdate>
                              {({ getFieldValue }) => {
                                const _row = (getFieldValue('insumos') || [])[arrayKey];
                                const _lotes = _row?.lotes || [];
                                const _insumo = this.state.todasInsumos?.find(i => i._id === _row?.insumoId);
                                const _necesitaLotes = _insumo?.lotesCaducidades;
                                const _recibir = Number(_row?.recibir) || 0;
                                const _sumLotes = _lotes.reduce((s, l) => s + (Number(l.cantidad) || 0), 0);
                                const isRed = _necesitaLotes && _recibir > 0 && _sumLotes !== _recibir;
                                return (
                            <tbody
                              key={fieldKey}
                              id={`insumo-row-${arrayKey}`}
                              style={{
                                ...(this.state.insumoResaltado === arrayKey
                                  ? { backgroundColor: "#fffbe6", outline: "2px solid #faad14", transition: "all 0.3s" }
                                  : isRed ? { backgroundColor: '#ffccc7' }
                                  : (isRecibido ? { backgroundColor: "#f5f5f5", opacity: 0.85 } : {})),
                              }}
                            >
                              <tr>
                                <td className="td-border">
                                  <FormItem {...restField} name={[name, "insumoId"]} fieldKey={[fieldKey, "insumoId"]} required noStyle>
                                    <SelectItem sinBorde autoFocus style={{ width: "100%" }} placeholder="Insumo" disabled>
                                      {this.state.objetoInsumos}
                                    </SelectItem>
                                  </FormItem>
                                </td>
                                <td className="td-border">
                                  <FormItem {...restField} name={[name, "proyectoId"]} fieldKey={[arrayKey, "proyectoId"]} required noStyle>
                                    <SelectItem sinBorde style={{ width: "100%" }} placeholder="Proyecto" disabled={isRecibido}>
                                      {this.state.objetoProyectos}
                                    </SelectItem>
                                  </FormItem>
                                </td>
                                <td className="td-border">
                                  <FormItem {...restField} name={[name, "precioUnitarioAjustado"]} fieldKey={[fieldKey, "precioUnitarioAjustado"]} noStyle>
                                    <InputNumberItem sinBorde placeholder="Precio Unitario" disabled dineroDisabled />
                                  </FormItem>
                                </td>
                                <td className="td-border">
                                  <FormItem {...restField} name={[name, "cantidad"]} fieldKey={[fieldKey, "cantidad"]} required number noStyle>
                                    <InputNumberItem sinBorde placeholder="Cantidad Pedida" disabled />
                                  </FormItem>
                                </td>
                                <td className="td-border">
                                  <FormItem {...restField} name={[name, "recibido"]} fieldKey={[fieldKey, "recibido"]} required numberCero noStyle initialValue={0}>
                                    <InputNumberItem sinBorde placeholder="Cantidad Recibida" disabled />
                                  </FormItem>
                                </td>
                                <td className="td-border">
                                  <FormItem shouldUpdate noStyle>
                                    {() => {
                                      let cantidad = this.state.datosFactura.insumos[fieldKey].cantidad;
                                      let recibido = this.state.datosFactura.insumos[fieldKey].recibido;
                                      let max = recibido ? cantidad - recibido : cantidad;
                                      
                                      return (
                                        <FormItem {...restField} name={[name, "recibir"]} fieldKey={[fieldKey, "recibir"]} number noStyle max={max} type="number">
                                          <InputNumberItem
                                            sinBorde
                                            placeholder={"Max: " + max}
                                            disabled={isRecibido}
                                          />
                                        </FormItem>
                                      );
                                    }}
                                  </FormItem>
                                </td>
                                <td className="td-border-sin-right">
                                  <Row>
                                    <Col span={24}>
                                      <FormItem noStyle shouldUpdate>
                                        {({ getFieldValue }) => {
                                          let arrayValue = getFieldValue("insumos");
                                          let mostrarMarbetes = false;
                                          let mostrarLotes = false;
                                          let mostrarVehiculo = false;
                                          let insumo = null;
                                          if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                                            insumo = this.state.todasInsumos.find((valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId);
                                            mostrarMarbetes = insumo?.marbetes;
                                            mostrarLotes = insumo?.lotesCaducidades;
                                            mostrarVehiculo = insumo?.vehiculo;
                                          }
                                          if (mostrarMarbetes) {
                                            return (
                                              <ButtonItem type="primary" size="small" block disabled={isRecibido} onClick={() => { this.abrirAgregarMarbetes(arrayKey, arrayValue[arrayKey].marbetes); }}>
                                                Marbetes
                                              </ButtonItem>
                                            );
                                          }
                                          if (mostrarLotes) {
                                            return (
                                              <ButtonItem type="primary" size='small' block disabled={isRecibido} 
                                              onClick={() => {
                                                const insumoId = insumo?.insumoId || insumo?.insumoPrincipalId;
                                                 this.abrirAgregarLotes(arrayKey, arrayValue[arrayKey]?.lotes, mostrarVehiculo, insumoId) }}>
                                                {this.props.taxidermia ? 'Animales' : 'Lotes'}
                                              </ButtonItem>
                                            );
                                          }
                                        }}
                                      </FormItem>
                                    </Col>
                                  </Row>
                                </td>
                              </tr>
                              {this.state.mostrarDetalles && (
                                <FormItem noStyle shouldUpdate={(prevValues, currentValues) => {
                                  const prev = prevValues.insumos[arrayKey];
                                  const curr = currentValues.insumos[arrayKey];
                                  return (
                                    prev?.recibir !== curr?.recibir ||
                                    prev?.insumoId !== curr?.insumoId ||
                                    prev?.precioUnitario !== curr?.precioUnitario
                                  );
                                }}>
                                  {({ getFieldValue }) => {
                                    const insumos = getFieldValue("insumos");
                                    const insumoData = insumos[arrayKey];
                                    const cantidad = insumoData?.recibir;
                                    const insumoId = insumoData?.insumoId;
                                    const costo = insumoData?.precioUnitario;
                                    let insumo = null;
                                    
                                    if (insumoId && this.state.todasInsumos) {
                                      insumo = this.state.todasInsumos.find((valueInsumos) => valueInsumos._id === insumoId);
                                    }

                                    if (!insumo) {
                                      return null;
                                    }

                                    return (
                                      <InsumoDetalleRow
                                        insumo={insumo}
                                        cantidad={cantidad}
                                        costo={costo}
                                        colSpans={{ details: 3, projection: 3, filler: 1 }}
                                        onCloseModal={() => { this.consultarTodo(); }}
                                      />
                                    );
                                  }}
                                </FormItem>
                              )}
                              {this.state.expandirLotes && _necesitaLotes && (
                                <tr>
                                  <td colSpan={7} style={{ padding: '8px 20px 8px 32px', background: '#fafafa', borderBottom: '2px solid #d9d9d9' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #d9d9d9', borderRadius: 4 }}>
                                      <thead>
                                        <tr style={{ background: '#f0f0f0' }}>
                                          <th style={{ textAlign: 'left', padding: '5px 10px', fontSize: 12, width: '30%', borderRight: '1px solid #d9d9d9', borderBottom: '1px solid #d9d9d9' }}>Número</th>
                                          <th style={{ textAlign: 'left', padding: '5px 10px', fontSize: 12, width: '30%', borderRight: '1px solid #d9d9d9', borderBottom: '1px solid #d9d9d9' }}>Caducidad</th>
                                          <th style={{ textAlign: 'left', padding: '5px 10px', fontSize: 12, width: '25%', borderRight: '1px solid #d9d9d9', borderBottom: '1px solid #d9d9d9' }}>Cantidad</th>
                                          <th style={{ width: '15%', borderBottom: '1px solid #d9d9d9' }}></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {_lotes.map((lote, loteIdx) => (
                                          <tr key={loteIdx} style={{ borderBottom: '1px solid #e8e8e8' }}>
                                            <td style={{ padding: '2px 4px', borderRight: '1px solid #e8e8e8' }}>
                                              <InputItem
                                                sinBorde
                                                id={`lote-numero-${arrayKey}-${loteIdx}`}
                                                placeholder="Núm. lote *"
                                                value={lote.numero || ''}
                                                onChange={(e) => this.updateLoteField(arrayKey, loteIdx, 'numero', e.target.value)}
                                                style={{ borderBottom: !lote.numero?.toString().trim() ? '1px solid #ff4d4f' : undefined }}
                                              />
                                            </td>
                                            <td style={{ padding: '2px 4px', borderRight: '1px solid #e8e8e8' }}>
                                              <DatePickerItem
                                                placeholder="Caducidad"
                                                style={{ width: '100%' }}
                                                value={lote.caducidad ? moment(lote.caducidad) : null}
                                                onChange={(date) => this.updateLoteField(arrayKey, loteIdx, 'caducidad', date)}
                                              />
                                            </td>
                                            <td style={{ padding: '2px 4px', borderRight: '1px solid #e8e8e8' }}>
                                              <InputNumberItem
                                                sinBorde
                                                placeholder="Cantidad"
                                                value={lote.cantidad}
                                                onChange={(val) => this.updateLoteField(arrayKey, loteIdx, 'cantidad', val)}
                                                onKeyDown={(e) => {
                                                  if (e.key === 'Tab' && loteIdx === _lotes.length - 1) {
                                                    e.preventDefault();
                                                    this.agregarLoteInline(arrayKey);
                                                    setTimeout(() => {
                                                      const el = document.getElementById(`lote-numero-${arrayKey}-${_lotes.length}`);
                                                      if (el) el.focus();
                                                    }, 50);
                                                  }
                                                }}
                                              />
                                            </td>
                                            <td style={{ padding: '2px 8px', textAlign: 'center' }}>
                                              <ButtonItem size="small" lessTime danger onClick={() => this.eliminarLoteInline(arrayKey, loteIdx)}>âœ•</ButtonItem>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                      <tfoot>
                                        <tr>
                                          <td colSpan={4} style={{ padding: '4px 8px', borderTop: '1px solid #d9d9d9' }}>
                                            <ButtonItem size="small" lessTime blanco type="dashed" onClick={() => this.agregarLoteInline(arrayKey)} block>
                                              + Agregar Lote
                                            </ButtonItem>
                                          </td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                                );
                              }}
                            </FormItem>
                          );
                        };

                        return (
                          <>
                            {pendientes.length > 0 && (
                              <tbody>
                                <tr>
                                  <td colSpan="7" style={{ padding: 0, border: 'none' }}>
                                    <div
                                      onClick={() => this.setState({ colapsadoSinRecibir: !this.state.colapsadoSinRecibir })}
                                      style={{
                                        background: "#e6f7ff", borderLeft: "4px solid #1890ff",
                                        padding: "10px 15px", cursor: "pointer", display: "flex", justifyContent: "space-between",
                                        fontWeight: "bold", color: "#0050b3", marginTop: 10, marginBottom: 5
                                      }}
                                    >
                                      <span><HourglassOutlined style={{ marginRight: 8 }} /> Sin recibir / Incompletos ({pendientes.length})</span>
                                      <span>{this.state.colapsadoSinRecibir ? <><CaretDownOutlined /> Mostrar</> : <><CaretUpOutlined /> Ocultar</>}</span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            )}
                            {!this.state.colapsadoSinRecibir && pendientes.map(renderFila)}

                            {recibidos.length > 0 && (
                              <tbody>
                                <tr>
                                  <td colSpan="7" style={{ padding: 0, border: 'none' }}>
                                    <div
                                      onClick={() => this.setState({ colapsadoRecibidos: !this.state.colapsadoRecibidos })}
                                      style={{
                                        background: "#f6ffed", borderLeft: "4px solid #52c41a",
                                        padding: "10px 15px", cursor: "pointer", display: "flex", justifyContent: "space-between",
                                        fontWeight: "bold", color: "#237804", marginTop: 10, marginBottom: 5
                                      }}
                                    >
                                      <span><CheckCircleOutlined style={{ marginRight: 8 }} /> Recibidos completamente ({recibidos.length})</span>
                                      <span>{this.state.colapsadoRecibidos ? <><CaretDownOutlined /> Mostrar</> : <><CaretUpOutlined /> Ocultar</>}</span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            )}
                            {!this.state.colapsadoRecibidos && recibidos.map(renderFila)}
                          </>
                        );
                      })()}
                    </table>
                  </>
                )}
              </FormInitial.List>
            </Form>
          </Spin>
        </div>
        <AgregarMarbetes
          visible={this.state.modalAgregarMarbetes}
          cerrarAgregarMarbetes={this.cerrarAgregarMarbetes.bind(this)}
          marbetes={this.state.modalAgregarMarbetesMarbetes}
        />
        <AgregarLotes
          visible={this.state.modalAgregarLotes}
          cerrarAgregarLotes={this.cerrarAgregarLotes.bind(this)}
          lotes={this.state.modalAgregarLotesLotes}
          vehiculo={this.state.modalAgregarLotesVehiculo}
          insumoId = { this.state.modalAgregarLotesInsumoId}
        />
        {(() => {
          const lotes = this.state.modalLotesRapidoLotes;
          const idx = this.state.modalLotesRapidoIndex;
          const insumoId = idx !== null
            ? (this.formRef.current?.getFieldValue('insumos') || [])[idx]?.insumoId
            : null;
          const insumoInfo = insumoId ? this.state.todasInsumos?.find(i => i._id === insumoId) : null;
          const sumaLotes = lotes.reduce((s, l) => s + (Number(l.cantidad) || 0), 0);
          const titulo = insumoInfo
            ? `Lotes: ${insumoInfo.clave || ''} â€” ${insumoInfo.descripcion || ''}`
            : 'Captura de Lotes';
          return (
            <ModalItem
              title={titulo}
              visible={this.state.modalLotesRapido}
              onCancel={this.cerrarModalLotesRapido}
              spinning={false}
              width={620}
              destroyOnClose={false}
              footer={[
                <span key="total" style={{ float: 'left', lineHeight: '32px', color: '#555', fontSize: 13 }}>
                  Total: <strong>{sumaLotes}</strong>
                </span>,
                <ButtonItem key="cancel" onClick={this.cerrarModalLotesRapido}>
                  Cancelar
                </ButtonItem>,
                <ButtonItem key="ok" type="primary" onClick={this.confirmarLotesRapido}>
                  OK â†µ
                </ButtonItem>,
              ]}
            >
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f5f5f5' }}>
                    <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 12, borderBottom: '1px solid #d9d9d9', width: '34%' }}>Lote *</th>
                    <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 12, borderBottom: '1px solid #d9d9d9', width: '34%' }}>Caducidad</th>
                    <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 12, borderBottom: '1px solid #d9d9d9', width: '22%' }}>Cantidad</th>
                    <th style={{ width: '10%', borderBottom: '1px solid #d9d9d9' }} />
                  </tr>
                </thead>
                <tbody>
                  {lotes.map((lote, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ padding: '2px 4px' }}>
                        <InputItem
                          sinBorde
                          id={`rapid-lote-numero-${i}`}
                          placeholder="Núm. lote"
                          value={lote.numero || ''}
                          onChange={(e) => this.updateLoteRapido(i, 'numero', e.target.value)}
                          style={{ borderBottom: lote.numero?.toString().trim() ? '1px solid transparent' : '1px solid #ff4d4f' }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              document.getElementById(`rapid-lote-cantidad-${i}`)?.focus();
                            }
                          }}
                        />
                      </td>
                      <td style={{ padding: '2px 4px' }}>
                        <DatePickerItem
                          placeholder="Caducidad"
                          style={{ width: '100%' }}
                          value={lote.caducidad ? moment(lote.caducidad) : null}
                          onChange={(date) => this.updateLoteRapido(i, 'caducidad', date)}
                          format="DD/MM/YYYY"
                        />
                      </td>
                      <td style={{ padding: '2px 4px' }}>
                        <InputNumberItem
                          sinBorde
                          id={`rapid-lote-cantidad-${i}`}
                          placeholder="Cant."
                          value={lote.cantidad}
                          min={0}
                          onChange={(val) => this.updateLoteRapido(i, 'cantidad', val)}
                          onKeyDown={(e) => {
                            if (e.key === 'Tab') {
                              e.preventDefault();
                              const nextI = i + 1;
                              if (nextI >= lotes.length) {
                                this.agregarFilaLoteRapido(() => {
                                  setTimeout(() => document.getElementById(`rapid-lote-numero-${nextI}`)?.focus(), 50);
                                });
                              } else {
                                document.getElementById(`rapid-lote-numero-${nextI}`)?.focus();
                              }
                            } else if (e.key === 'Enter') {
                              e.preventDefault();
                              this.confirmarLotesRapido();
                            }
                          }}
                        />
                      </td>
                      <td style={{ padding: '2px 8px', textAlign: 'center' }}>
                        <ButtonItem size="small" lessTime danger onClick={() => this.eliminarFilaLoteRapido(i)}>
                          âœ•
                        </ButtonItem>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={4} style={{ padding: '6px 4px', borderTop: '1px solid #d9d9d9' }}>
                      <ButtonItem
                        size="small"
                        lessTime
                        type="dashed"
                        blanco
                        onClick={() => this.agregarFilaLoteRapido(() => {
                          const newIdx = this.state.modalLotesRapidoLotes.length - 1;
                          setTimeout(() => document.getElementById(`rapid-lote-numero-${newIdx}`)?.focus(), 50);
                        })}
                        block
                      >
                        + Agregar Lote
                      </ButtonItem>
                    </td>
                  </tr>
                </tfoot>
              </table>
              <div style={{ marginTop: 8, color: '#aaa', fontSize: 11 }}>
                <strong>Enter</strong> en Lote â†’ salta a Cantidad &nbsp;|&nbsp; <strong>Tab</strong> en Cantidad â†’ agrega fila &nbsp;|&nbsp; <strong>Enter</strong> en Cantidad â†’ confirmar
              </div>
            </ModalItem>
          );
        })()}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(RecibirInsumosRemision);
